"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = require("react");

var _reactDom = _interopRequireDefault(require("react-dom"));

var Portal = function Portal(_ref) {
  var children = _ref.children,
      containerEl = _ref.containerEl;

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      container = _useState2[0],
      setContainer = _useState2[1];

  (0, _react.useEffect)(function () {
    if (containerEl) {
      setContainer(containerEl);
    } else {
      setContainer(document.body);
    }
  }, [containerEl]);

  if (container) {
    return _reactDom["default"].createPortal(children, container);
  }

  return null;
};

var _default = Portal;
exports["default"] = _default;
//# sourceMappingURL=index.js.map